export const handleServerResponse = async response => {
    const stripe = Stripe(window.stripeKey);
    if (response.error) {
        console.log(response.error);
        return {error: response.error}
    } else if (response.requires_action) {
        const {
            error,
            paymentIntent
        } = await stripe.confirmCardPayment(response.payment_intent_client_secret);

        if (error) {
           return {error: error}
        } else {
            console.log(paymentIntent);
            return {
                needComfirm: true,
                paymentIntent: paymentIntent
            };
        }
    }else{
        return 'ok';
    }
};
